import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { X, ChevronDown, LayoutGrid, CircleHelp, Moon, Sun, Mic, MessageSquareWarning } from "lucide-react";
import { hubTotaal } from "./V3Rail";

function HubSectie({ h, counts, open, onOpen, onClose }) {
  const Icon = h.icon;
  const n = hubTotaal(h, counts);
  return (
    <section>
      <button type="button" className="v3-meer-hub" aria-expanded={open} onClick={onOpen} data-testid={`v3-meer-hub-${h.key}`}>
        <Icon /><span className="flex-1 min-w-0 truncate text-left">{h.label}</span>
        {n > 0 && <span className="v3-badge">{n > 99 ? "99+" : n}</span>}
        <ChevronDown className="v3-meer-pijl" />
      </button>
      {open && (
        <div className="v3-meer-items">
          {h.items.map((it) => {
            const ItIcon = it.icon;
            const c = it.counter ? counts[it.counter] || 0 : 0;
            return (
              <NavLink key={it.to} to={it.to} onClick={onClose} className={({ isActive }) => `v3-item${isActive ? " actief" : ""}`} data-testid={`v3-meer-item-${it.tid}`}>
                {ItIcon ? <ItIcon /> : null}
                <span className="min-w-0 flex-1"><span className="v3-nm block truncate">{it.label}</span>{it.beschrijving && <span className="v3-sub block truncate">{it.beschrijving}</span>}</span>
                {c > 0 && <span className="v3-badge">{c > 99 ? "99+" : c}</span>}
              </NavLink>
            );
          })}
        </div>
      )}
    </section>
  );
}

/** Layout v3 telefoon: 'Meer' — alle hubs met hun onderdelen (rechten bepalen zoals altijd wat erin staat). */
export function V3MeerSheet({ hubs, counts, actiefDomein, onClose, thema, onThema }) {
  const [open, setOpen] = useState(actiefDomein || null);
  const fab = (tid) => document.querySelector(`[data-testid='${tid}']`);
  const [fabs] = useState(() => ({ meld: !!fab("meldknop"), spraak: !!fab("floating-voice-fab") }));
  const klikFab = (tid) => { onClose(); setTimeout(() => fab(tid)?.click(), 50); };
  useEffect(() => {
    const t = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", t);
    document.body.style.overflow = "hidden";
    document.body.classList.add("v3-meer-open");
    return () => { document.removeEventListener("keydown", t); document.body.style.overflow = ""; document.body.classList.remove("v3-meer-open"); };
  }, [onClose]);
  return (
    <div className="v3-meer" role="dialog" aria-modal="true" aria-label="Menu — alle onderdelen" data-testid="v3-meer">
      <div className="v3-meer-kop">
        <h2>Menu</h2>
        <button type="button" className="v3-iconbtn" onClick={onClose} aria-label="Menu sluiten" data-testid="v3-meer-sluiten"><X /></button>
      </div>
      <div className="v3-meer-body">
        {hubs.map((h) => <HubSectie key={h.key} h={h} counts={counts} open={open === h.key} onOpen={() => setOpen((o) => (o === h.key ? null : h.key))} onClose={onClose} />)}
      </div>
      <div className="v3-meer-voet">
        <Link to="/alle-tools" onClick={onClose} className="v3-btn" data-testid="v3-meer-alle-tools"><LayoutGrid /> Alle tools</Link>
        <Link to="/handboek" onClick={onClose} className="v3-btn" data-testid="v3-meer-handboek"><CircleHelp /> Handboek</Link>
        <button type="button" className="v3-btn" onClick={onThema} data-testid="v3-meer-thema">{thema === "donker" ? <Sun /> : <Moon />} {thema === "donker" ? "Licht" : "Donker"}</button>
        {fabs.meld && <button type="button" className="v3-btn" onClick={() => klikFab("meldknop")} data-testid="v3-meer-melden"><MessageSquareWarning /> Iets melden</button>}
        {fabs.spraak && <button type="button" className="v3-btn" onClick={() => klikFab("floating-voice-fab")} data-testid="v3-meer-spraak"><Mic /> Spraak</button>}
      </div>
    </div>
  );
}
